module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-bold.woff2
// module id = kYlC
// module chunks = 0